import * as React from 'react';
import { inject, observer } from 'mobx-react';
import {
  PRODUCT_STORE,
  CART_STORE,
  ORDER_FORM_STORE,
  ORDER_TYPES_STORE,
  COMPANY_STORE,
  CUSTOMER_STORE,
  FEEDBACK_STORE,
  NOTIFICATION_STORE,
  MODAL_STORE,
  FILTER_STORE } from '../constants/constants';
import Modal from './Modal';
import Spinner from './Spinner';
import ModalStore from '../stores/ModalStore';

@inject(
  PRODUCT_STORE,
  CART_STORE,
  ORDER_FORM_STORE,
  ORDER_TYPES_STORE,
  COMPANY_STORE,
  CUSTOMER_STORE,
  FEEDBACK_STORE,
  NOTIFICATION_STORE,
  MODAL_STORE,
  FILTER_STORE)
@observer
class ModalContainer extends React.Component {

/**
 * Modal submit/close event handler
 *
 * @param {boolean} submit confirm action
 * @memberof ModalContainer
 */
async closeModal(submit: boolean) {
    const feedback = this.props[FEEDBACK_STORE].feedback;
    const modalStore = this.props[MODAL_STORE] as ModalStore;

    if (submit) {
      switch (modalStore.modalTrigger) {
        // When sending feedback
        case 'feedback':
          if (feedback.title && feedback.body) {
            this.props[MODAL_STORE].clearErrors();
            this.props[MODAL_STORE].setChildren(<Spinner />);

            const data = await this.props[FEEDBACK_STORE].sendFeedback()
              .then(response => {
                return response.json();
              })
              .catch(e => {
                return { status: 500, message: e };
              });

            if (data.status && data.status === 200) {
              // @TODO: Do something when everything worked?
            } else {
              this.props[NOTIFICATION_STORE].addNotification({
                type: 'error',
                message: 'Virhe palautetta lähettäessä',
                seen: false
              });
            }

            this.props[MODAL_STORE].onlyCloseButton = true;
            this.props[MODAL_STORE].setTitle(<h2>Palaute lähetetty</h2>);
            this.props[MODAL_STORE].setChildren(<h2>Kiitos palautteesta</h2>);
          } else {
            this.props[MODAL_STORE].addError('Täytä kaikki kentät');
          }
          break;
        // When changing company
        case 'companyChange':
          if (modalStore.data) {
            this.props[COMPANY_STORE].setCompany(modalStore.data);
            this.props[CART_STORE].clearStore();
            this.props[ORDER_FORM_STORE].clearStore();

            this.props[PRODUCT_STORE].fetchProducts();
            this.props[ORDER_TYPES_STORE].getOrderTypes();
            this.props[CUSTOMER_STORE].fetchCustomers();
            this.props[FILTER_STORE].fetchFilters();
            this.closeModal(false);
          }
          break;
        default:
          this.closeModal(false);
          break;
      }

    } else {
      this.props[MODAL_STORE].closeModal();
      this.props[MODAL_STORE].clearStore();
    }
  }

  render() {
    const modalStore = this.props[MODAL_STORE];
    return (
      <Modal
        title={modalStore.modalTitle}
        close={value => this.closeModal(value)}
        show={modalStore.isModalOpen}
        errorText={modalStore.modalErrors}
        errorClass={modalStore.modalErrors.length > 0}
        onlyCloseButton={modalStore.modalOnlyCloseButton}
        size={modalStore.modalSize}
      >
        {modalStore.modalChildren}
      </Modal>
    );
  }
}

export default ModalContainer;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ModalContainer.tsx